export const ROLE_ADMIN = 'ADMIN'
export const ROLE_IMINIMO = 'INGRESOMINIMO'
export const ROLE_ICOMPLETO = 'INGRESOCOMPLETO'
export const ROLE_ADMINCUPOS = 'ADMINCUPOS'
export const ROLE_ADMINEMBARQUE = 'ADMINEMBARQUE'
export const ROLE_AUDITOR = 'AUDITOR'
export const ROLE_BALANCEROCAMIONES = 'BALANCEROCAMIONES'
export const ROLE_BALANCEROEMBARQUE = 'BALANCEROEMBARQUE'
export const ROLE_CARGADOR = 'CARGADOR'
export const ROLE_CORREDOR = 'CORREDOR'
export const ROLE_DESARROLLADOR = 'DESARROLLADOR'
export const ROLE_EGRESOPLAYA = 'EGRESOPLAYA'
// Rol utilizado por las Malterias
export const ROLE_ENTREGADORCALADO = 'ENTREGADORCALADO'
// ***
export const ROLE_EXPORTADOR = 'EXPORTADOR'
// Rol utilizado para limitar operaciones a exportador solo para consulta
export const ROLE_EXPORTADOR_CONSULTA = 'EXPORTADOR_CONSULTA'
export const ROLE_ICALADO = 'INGRESOCALADO'
export const ROLE_PREINGRESOCALADO = 'PREINGRESOCALADO'
export const ROLE_MOVIMIENTO = 'MOVIMIENTO'
export const ROLE_OPSTOCK = 'OPSTOCK'
export const ROLE_OPVOLCADORA = 'OPVOLCADORA'
export const ROLE_PERITOEMBARQUE = 'PERITOEMBARQUE'
export const ROLE_PLANILLERO = 'PLANILLERO'
export const ROLE_SECRETARIA = 'SECRETARIA'
// Averiguar quien utiliza este rol ademas de Casal
export const ROLE_SINENTREGADOR = 'SINENTREGADOR'
// ***
export const ROLE_SUPERVISOR = 'SUPERVISOR'
export const ROLE_SUPCONSULTA = 'SUPCONSULTA'
export const ROLE_SUPMANTENIMIENTO = 'SUPMANTENIMIENTO'
export const ROLE_VENDEDOR = 'VENDEDOR'
// Rol utilizado por rep. de entregadores y sycap en el calado
export const ROLE_CONSULTA_VENDEDOR = 'CONSULTA_VENDEDOR'
// ***
export const ROLE_VIGILANCIA = 'VIGILANCIA'
// export const ROLE_PUBLIC = 'PUBLIC'

/**
 * ROLE_MALTERIA
 * Combinación de rol exportador y entregadorCalado para malterias
 * Se deben asignar los dos roles al usuario en la base
 */
const ROLE_MALTERIA = ROLE_EXPORTADOR && ROLE_ENTREGADORCALADO

export const COMPONENT_PERMS = {
  '/cupos/modificacion': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_ADMINCUPOS,
    ROLE_SECRETARIA
  ],
  '/cupos/asignacion': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_ADMINCUPOS,
    ROLE_SECRETARIA,
    ROLE_EXPORTADOR
  ],
  '/cupos/nominados': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_ADMINCUPOS,
    ROLE_EXPORTADOR,
    ROLE_SECRETARIA,
    ROLE_CARGADOR
  ],
  '/cupos/adelanto': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SECRETARIA
  ],
  '/cupos/bloqueo': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_ADMINCUPOS,
    ROLE_SECRETARIA
  ],
  '/cupos/nominacion': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_ADMINCUPOS,
    ROLE_SECRETARIA,
    ROLE_EXPORTADOR
  ],
  '/cupos/cumplimiento': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO,
    ROLE_EXPORTADOR
  ],
  '/calado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ICALADO,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR,
    ROLE_CONSULTA_VENDEDOR,
    ROLE_PREINGRESOCALADO,
    ROLE_MALTERIA
  ],
  '/preingresoCalado/1-2': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_PREINGRESOCALADO
  ],
  '/preingresoCalado/3-4': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_PREINGRESOCALADO
  ],
  '/calado/proceso': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ICALADO,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR
  ],
  '/calado/cargaspendientes': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR,
    ROLE_MALTERIA,
    ROLE_CONSULTA_VENDEDOR
  ],
  '/calado/camionescalados': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_EXPORTADOR
  ],
  '/calado/egresocalado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR
  ],
  '/calado/callesdecalado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR
  ],
  '/calado/egresoqrcalado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR
  ],
  '/calado/anulacionegreso': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR
  ],
  '/calado/muestras': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ICALADO,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR
  ],
  '/calado/consultaMuestras': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ICALADO,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR
  ],
  '/calado/pedidosegresocalado': [
    // ROLE_ADMIN,
    // ROLE_DESARROLLADOR,
    // ROLE_ICALADO,
    // ROLE_PLANILLERO,
    // ROLE_SUPERVISOR
  ],
  '/cuadroDeMando': [
    ROLE_ADMIN,
    ROLE_ADMINCUPOS,
    ROLE_DESARROLLADOR,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR
  ],
  '/cuadroDeMando/pbi': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/cuadroDeMando/ReportePbiDesYEmbOnline': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/cuadroDeMando/ReportePbiEmbarque': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/cuadroDeMando/ReportePbiDescarga': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/cuadroDeMando/ReporteStockExportadores': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/cuadroDeMando/ReportePbiMermasYCalidad': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/cuadroDeMando/ReporteExistenciasOnline': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/cuadroDeMando/cdmd': [
    ROLE_ADMIN,
    ROLE_ICOMPLETO,
    ROLE_ADMINCUPOS,
    ROLE_DESARROLLADOR,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR
  ],
  '/movimiento': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/abm': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/vista3d': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR
  ],
  '/movimiento/reportePorSilos': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/reportePorSector': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/planillaParaEmbarque': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  // Estaba comentado
  '/movimiento/reportePorSectorYLinea': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/reportesTotales': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  // hasta aca
  '/movimiento/reportePorCereal': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  // revisar
  '/movimiento/modificarCuenta': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR
  ],
  //
  '/movimiento/cuadroDeMando': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/distribucionPorCereal': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/distribucionPorCondicion': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/espacioPorCereal': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/reporteParaEmbarque': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],

  '/movimiento/listado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/movimiento/listado/consultaMovimientosMercaderia': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_MOVIMIENTO
  ],
  '/consultacpaabandonada': [
    ROLE_ADMIN,
    ROLE_IMINIMO,
    ROLE_ICOMPLETO,
    ROLE_ADMINCUPOS,
    ROLE_DESARROLLADOR,
    ROLE_OPSTOCK,
    ROLE_SUPERVISOR
  ],
  '/cupos': [
    ROLE_ADMIN,
    ROLE_ADMINCUPOS,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_DESARROLLADOR,
    ROLE_EXPORTADOR,
    ROLE_OPSTOCK,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPCONSULTA,
    ROLE_VENDEDOR,
    ROLE_IMINIMO,
    ROLE_ICOMPLETO
    // ROLE_SINENTREGADOR
  ],
  '/consultaCupo': [
    ROLE_ADMIN,
    ROLE_IMINIMO,
    ROLE_ICOMPLETO,
    ROLE_ADMINCUPOS,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_DESARROLLADOR,
    ROLE_EXPORTADOR,
    ROLE_ICALADO,
    ROLE_OPSTOCK,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPCONSULTA,
    ROLE_VENDEDOR
    // ROLE_SINENTREGADOR
  ],
  '/ingreso/anulacioningreso': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_IMINIMO,
    ROLE_ICOMPLETO,
    ROLE_ADMINCUPOS,
    ROLE_SUPERVISOR
  ],
  '/ingreso/abandono': [
    ROLE_ADMIN,
    ROLE_IMINIMO,
    ROLE_ICOMPLETO,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/ingreso/desabandono': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/ingreso/rechazoenplaya': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/ingreso/egresoplaya': [
    ROLE_ADMIN,
    ROLE_ICOMPLETO,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/ingreso/pedidoegresoplaya': [
    ROLE_ADMIN,
    ROLE_ICOMPLETO,
    ROLE_ICALADO,
    ROLE_PLANILLERO,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/volcado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/emision': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/notificacioneschofer': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/camiones': [
    ROLE_ICOMPLETO,
    ROLE_IMINIMO,
    ROLE_AUDITOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_EXPORTADOR,
    ROLE_ICALADO,
    ROLE_MOVIMIENTO,
    ROLE_OPSTOCK,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    ROLE_SINENTREGADOR,
    ROLE_SUPERVISOR,
    ROLE_VENDEDOR,
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_CONSULTA_VENDEDOR
  ],
  '/ingreso': [
    ROLE_ICOMPLETO,
    ROLE_IMINIMO,
    ROLE_AUDITOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_CARGADOR,
    // ROLE_CORREDOR,
    // ROLE_EXPORTADOR,
    ROLE_ICALADO,
    ROLE_MOVIMIENTO,
    ROLE_OPSTOCK,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    // ROLE_SINENTREGADOR,
    ROLE_SUPERVISOR,
    // ROLE_VENDEDOR,
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_CONSULTA_VENDEDOR
  ],
  '/camiones/modificarcpa': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/listados/camiones': [
    ROLE_ICOMPLETO,
    ROLE_IMINIMO,
    ROLE_AUDITOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_EXPORTADOR,
    ROLE_ICALADO,
    ROLE_MOVIMIENTO,
    ROLE_OPSTOCK,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    ROLE_SINENTREGADOR,
    ROLE_SUPERVISOR,
    ROLE_VENDEDOR,
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_CONSULTA_VENDEDOR
  ],
  '/ingreso/minimo': [
    ROLE_ICOMPLETO,
    ROLE_IMINIMO,
    ROLE_OPSTOCK,
    ROLE_SUPERVISOR,
    ROLE_ADMIN,
    ROLE_DESARROLLADOR
  ],
  '/ingreso/completo': [
    ROLE_ICOMPLETO,
    ROLE_OPSTOCK,
    ROLE_SUPERVISOR,
    ROLE_ADMIN,
    ROLE_DESARROLLADOR
  ],
  '/ingreso/reimpresioncomprobante': [
    ROLE_ICOMPLETO,
    ROLE_OPSTOCK,
    ROLE_SUPERVISOR,
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ICALADO,
    ROLE_PLANILLERO
  ],
  '/ingreso/busquedacpa': [
    ROLE_ICOMPLETO,
    ROLE_OPSTOCK,
    ROLE_SUPERVISOR,
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ICALADO,
    ROLE_PLANILLERO,
    ROLE_CONSULTA_VENDEDOR
  ],
  '/pesado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_SUPERVISOR
  ],
  '/pesado/pesobruto': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_SUPERVISOR
  ],
  // '/pesado/rechazo': [
  //   ROLE_ADMIN,
  //   ROLE_DESARROLLADOR,
  //   ROLE_BALANCEROCAMIONES,
  //   ROLE_SUPERVISOR
  // ],
  // '/pesado/repesobruto': [
  //   ROLE_ADMIN,
  //   ROLE_DESARROLLADOR,
  //   ROLE_BALANCEROCAMIONES,
  //   ROLE_SUPERVISOR
  // ],
  // '/pesado/fueradecircuito': [
  //   ROLE_ADMIN,
  //   ROLE_DESARROLLADOR,
  //   ROLE_BALANCEROCAMIONES,
  //   ROLE_SUPERVISOR
  // ],

  '/pesado/actividadbarrera': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/pesado/pesodestare': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_SUPERVISOR
  ],
  '/pesado/reimpresioncomprobantedescarga': [
    ROLE_BALANCEROCAMIONES,
    ROLE_OPSTOCK,
    ROLE_SUPERVISOR,
    ROLE_ADMIN,
    ROLE_DESARROLLADOR
  ],
  '/trenes': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/trenes/ingreso/alta': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/trenes/ingreso/modificacion': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/trenes/ingreso/vagones': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/embarque': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_ADMINEMBARQUE,
    ROLE_BALANCEROEMBARQUE,
    ROLE_EXPORTADOR
  ],
  '/embarque/buques': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/embarque/supervisionembarque': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_EXPORTADOR
  ],
  '/embarque/comunicacionEmbarque': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_ADMINEMBARQUE,
    ROLE_BALANCEROEMBARQUE
    // ROLE_EXPORTADOR
  ],
  '/embarque/plan': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/embarque/control': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/embarque/muestra': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/embarque/parte': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/embarque/demoras': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/embarque/anunciosbuques': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ],
  '/stock': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/listados': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/listados/mfumigada': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/listados/msecada': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/listados/mporgrado': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/listados/mrebajaadicional': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/listados/almacenaje': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/listados/almacenajeespecial': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/listados/mzarandeada': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/listados/indices': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/exportador': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/exportador/movimientosexportador': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/exportador/transferenciasexp': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/exportador/cambiocerealexportador': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/terminal': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/terminal/reconocimiento': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/terminal/ventasaexportador': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/controlexistencias': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/existenciadiaria': [
    ROLE_DESARROLLADOR,
    ROLE_OPSTOCK,
    ROLE_SUPERVISOR
  ],
  // '/stock/estimacionsemanal': [
  //   ROLE_DESARROLLADOR,
  //   ROLE_SUPERVISOR
  // ],
  '/stock/consultaporcosecha': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  // '/stock/rankingexportadores': [
  //   ROLE_DESARROLLADOR,
  //   ROLE_SUPERVISOR,
  //   ROLE_OPSTOCK
  // ],
  '/stock/calidad': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/calidad/archivoanalisis': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/calidad/importararchivoanalisis': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/calidad/solicitudanalisis': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/calidad/solicitudanalisisembarque': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],

  '/stock/calidad/mercaderiasinanalisis': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/calidad/mercaderiaembarcada': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/calidad/controldegrado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/calidad/calidadmercaderiaembarcada': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/calidad/controlderebajas': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/controlDiario': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/controlDiario/descargadiaria': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  '/stock/controlDiario/cargadiaria': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],
  // '/stock/controlDiario/descargaenextra': [
  //   ROLE_ADMIN,
  //   ROLE_DESARROLLADOR,
  //   ROLE_SUPERVISOR,
  //   ROLE_OPSTOCK
  // ],
  '/stock/controlDiario/ventaaexportador': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK
  ],

  // '/stock/calculoDeStock': [
  //   ROLE_ADMIN,
  //   ROLE_DESARROLLADOR,
  //   ROLE_SUPERVISOR,
  //   ROLE_OPSTOCK
  // ],
  // '/stock/interdictos': [
  //   ROLE_ADMIN,
  //   ROLE_DESARROLLADOR,
  //   ROLE_SUPERVISOR,
  //   ROLE_OPSTOCK
  // ],
  // '/stock/movimientosTerminal': [
  //   ROLE_ADMIN,
  //   ROLE_DESARROLLADOR,
  //   ROLE_SUPERVISOR,
  //   ROLE_OPSTOCK
  // ],
  // '/stock/generarArchivos': [
  //   ROLE_ADMIN,
  //   ROLE_DESARROLLADOR,
  //   ROLE_SUPERVISOR,
  //   ROLE_OPSTOCK
  // ],
  '/listado': [
    ROLE_DESARROLLADOR,
    ROLE_ICOMPLETO,
    ROLE_IMINIMO,
    ROLE_AUDITOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_EXPORTADOR,
    ROLE_ICALADO,
    ROLE_MOVIMIENTO,
    ROLE_OPSTOCK,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    ROLE_SINENTREGADOR,
    ROLE_SUPERVISOR,
    ROLE_VENDEDOR,
    ROLE_CONSULTA_VENDEDOR,
    ROLE_ADMIN
  ],
  '/listado/codigoCupo': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_EXPORTADOR,
    ROLE_SECRETARIA,
    ROLE_CORREDOR,
    ROLE_CARGADOR,
    ROLE_VENDEDOR
  ],
  '/listado/cartasDePorteVetadas': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ICOMPLETO,
    ROLE_ADMINCUPOS,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_ENTREGADORCALADO,
    ROLE_ICALADO,
    ROLE_OPSTOCK,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPCONSULTA,
    ROLE_VENDEDOR
  ],
  '/listado/listadoRepresentantes': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ENTREGADORCALADO,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO,
    ROLE_VENDEDOR,
    ROLE_CONSULTA_VENDEDOR
  ],
  '/listado/cpasincupo': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_IMINIMO,
    ROLE_ICOMPLETO,
    ROLE_ADMINCUPOS,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_ENTREGADORCALADO,
    ROLE_EXPORTADOR,
    ROLE_ICALADO,
    ROLE_OPSTOCK,
    ROLE_OPVOLCADORA,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPCONSULTA,
    ROLE_VENDEDOR
  ],
  '/listado/consultaCpaPlaya': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ADMIN,
    ROLE_IMINIMO,
    ROLE_ICOMPLETO,
    ROLE_ADMINCUPOS,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_ENTREGADORCALADO,
    ROLE_EXPORTADOR,
    ROLE_ICALADO,
    ROLE_OPSTOCK,
    ROLE_OPVOLCADORA,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPCONSULTA,
    ROLE_VENDEDOR,
    ROLE_CONSULTA_VENDEDOR
  ],
  '/listado/consultaCpaEntrePlayaCalado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ADMIN,
    ROLE_IMINIMO,
    ROLE_ICOMPLETO,
    ROLE_ADMINCUPOS,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_ENTREGADORCALADO,
    ROLE_EXPORTADOR,
    ROLE_ICALADO,
    ROLE_OPSTOCK,
    ROLE_OPVOLCADORA,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPCONSULTA,
    ROLE_VENDEDOR
  ],
  '/listado/consultaCaladoAceptado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_ICALADO,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR,
    ROLE_EXPORTADOR
  ],
  '/listado/consultaCaladoRechazado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_ICALADO,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR,
    ROLE_CONSULTA_VENDEDOR,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_EXPORTADOR
  ],
  '/listado/consultaCamionesPenalizados': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_ICALADO,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR,
    ROLE_CONSULTA_VENDEDOR
    // ROLE_CARGADOR
  ],
  '/listado/consultaCeaRechazadaAdministrativamente': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_ICALADO,
    ROLE_PLANILLERO,
    ROLE_SUPERVISOR,
    ROLE_EXPORTADOR,
    ROLE_CARGADOR,
    ROLE_CORREDOR
  ],
  '/listado/consultaCeaListaParaBrutoListado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_PLANILLERO,
    ROLE_CARGADOR,
    ROLE_CORREDOR
  ],
  '/listado/consultaCeaRechazadosBruto': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_PLANILLERO
  ],
  '/listado/consultaCeaConPesoListado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK,
    ROLE_BALANCEROCAMIONES,
    ROLE_EXPORTADOR,
    ROLE_CARGADOR,
    ROLE_CORREDOR
  ],
  '/listado/consultaCeaConVolcado': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_BALANCEROCAMIONES,
    ROLE_OPSTOCK
  ],
  '/listado/consultaCeaConPesoNeto': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK,
    ROLE_ENTREGADORCALADO,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO,
    ROLE_VENDEDOR,
    ROLE_SINENTREGADOR,
    ROLE_EXPORTADOR,
    ROLE_CARGADOR,
    ROLE_CORREDOR,
    ROLE_SECRETARIA
  ],
  '/listado/consultaDescargaProcesadaStock': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_OPSTOCK,
    ROLE_EXPORTADOR
  ],
  '/listado/consultaCpaSinDefinitiva': [
    ROLE_ADMIN,
    ROLE_DESARROLLADOR,
    ROLE_ADMIN,
    ROLE_IMINIMO,
    ROLE_ICOMPLETO,
    ROLE_ADMINCUPOS,
    // ROLE_CARGADOR,
    // ROLE_CORREDOR,
    ROLE_ICALADO,
    ROLE_OPSTOCK,
    ROLE_OPVOLCADORA,
    ROLE_PLANILLERO,
    ROLE_SECRETARIA,
    ROLE_SUPERVISOR,
    ROLE_SUPCONSULTA,
    ROLE_VENDEDOR
    // ROLE_SINENTREGADOR
  ],
  // '/externos': [
  //   ROLE_ADMIN,
  //   ROLE_DESARROLLADOR,
  //   ROLE_SUPERVISOR,
  //   ROLE_CORREDOR,
  //   ROLE_CARGADOR,
  //   ROLE_EXPORTADOR,
  //   ROLE_VENDEDOR
  // //  ROLE_SINENTREGADOR
  // ],
  '/accesosFrecuentes': [
    ROLE_DESARROLLADOR
    // ROLE_PUBLIC
  ],
  '/accesoPreingreso': [
    ROLE_PREINGRESOCALADO
  ],
  '/vigilancia': [
    ROLE_DESARROLLADOR,
    ROLE_VIGILANCIA
  ],
  '/vigilancia/barrerascalado': [
    ROLE_DESARROLLADOR,
    ROLE_VIGILANCIA
  ],
  '/supervisor': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/supervisor/configuracion': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/supervisor/configuraciondelsistema': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/supervisor/configuracioncereales': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/supervisor/penalizaciontransporte': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/supervisor/proyeccion': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/supervisor/proyeccionstock': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/supervisor/simularproyeccion': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/productividad': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/productividad/histogramas': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/productividad/estadisticasvolcadoras': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO
  ],
  '/utilidades': [
    ROLE_DESARROLLADOR
  ],
  '/utilidades/mensajeria': [
    ROLE_DESARROLLADOR
  ],
  '/ayuda': [
    ROLE_DESARROLLADOR
  ],
  '/tarifasvigentes': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO,
    ROLE_EXPORTADOR,
    ROLE_SECRETARIA,
    ROLE_CARGADOR,
    ROLE_CORREDOR
  ],
  '/manualdeservicio':
  [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO,
    ROLE_EXPORTADOR,
    ROLE_SECRETARIA,
    ROLE_CARGADOR,
    ROLE_CORREDOR
  ],
  '/alcancedesig': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO,
    ROLE_EXPORTADOR,
    ROLE_SECRETARIA,
    ROLE_CARGADOR,
    ROLE_CORREDOR
  ],
  '/politicaempresa': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR,
    ROLE_SUPMANTENIMIENTO,
    ROLE_EXPORTADOR,
    ROLE_SECRETARIA,
    ROLE_CARGADOR,
    ROLE_CORREDOR
  ],
  '/dashboardtqq': [
    ROLE_DESARROLLADOR,
    ROLE_SUPERVISOR
  ]
}
